const isDateAfterToday = (year, month, day) => {
  const date = new Date(year, month, day, 0, 0, 0, 0);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date.getTime() >= today.getTime();
};

export default isDateAfterToday;
